import { useMutation } from "react-query";
import http from "infra/http";
import { FormAcordo } from "../typings";

function useSaveAcordo() {
  return useMutation(
    (data: FormAcordo) => {
      return http.post(`/v1/acordo`, data);
    },
    { retry: false }
  );
}

export default useSaveAcordo;
